// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressPf_v-icon_kn7BG","nsAddressForm":"NsAddressPf_nsAddressForm_3GRoE","dualColumn":"NsAddressPf_dualColumn_29DGp","firstCol":"NsAddressPf_firstCol_3MI8I"};